export const reviews = [
  {
    id: 1,
    name: "Thomas Jensen",
    location: "Karup",
    rating: 5,
    text: "Super god og ærlig service! Mads fandt hurtigt fejlen på min bil og lavede den til en rigtig god pris. Kan varmt anbefales!",
    date: "For 2 uger siden"
  },
  {
    id: 2,
    name: "Signe Nielsen",
    location: "Skive",
    rating: 5,
    text: "Altid professionel behandling. Mads forklarer altid, hvad der skal laves, inden han går i gang. Meget tillidsvækkende og jordnær mekaniker.",
    date: "For 1 måned siden"
  },
  {
    id: 3,
    name: "Morten Hansen",
    location: "Grønhøj",
    rating: 5,
    text: "Fik skiftet dæk og lavet synsklargøring. Hurtigt, effektivt og uformelt. Det er herligt med et lokalt værksted, man kan stole 100% på.",
    date: "For 3 uger siden"
  },
  {
    id: 4,
    name: "Lene Søndergaard",
    location: "Viborg",
    rating: 5,
    text: "Mads er en fantastisk dygtig mekaniker. Han kan lave alt, og prisen er altid fair. Han fandt en fejl, som det autoriserede værksted havde overset.",
    date: "For 2 måneder siden"
  },
  {
    id: 5,
    name: "Kristian Poulsen",
    location: "Frederiks",
    rating: 5,
    text: "Fantastisk service! Min bil fik en mærkelig lyd på vej hjem, og Mads kiggede på den med det samme. Meget personligt, hurtigt og venligt.",
    date: "For 1 måned siden"
  }
];

export const keyServices = [
  {
    title: "Service & Reparation",
    slug: "service-og-reparation",
    icon: "fa-solid fa-wrench",
    description: "Professionelt eftersyn og mekanisk arbejde, der bevarer din fabriksgaranti. Vi bruger kun OE-godkendte reservedele."
  },
  {
    title: "Dæk & Hjul",
    slug: "daek-og-hjul",
    icon: "fa-solid fa-tire",
    description: "Hjulskift, afbalancering, sporing og salg af kvalitetsdæk fra førende mærker til skarpe priser."
  },
  {
    title: "Synsklargøring",
    slug: "synsklargoering",
    icon: "fa-solid fa-clipboard-check",
    description: "Grundig gennemgang af din bil før syn, så du undgår dyre omsyn. Vi kører også gerne bilen til syn for dig."
  }
];

export const contactInfo = {
  phone: "20 86 16 65",
  email: "Groenhoejauto@outlook.dk",
  address: "Grønhøjvej 1",
  postalCode: "7760 Hurup Thy",
  owner: "Mads Kallerup",
  hours: [
    { days: "Mandag - Torsdag", time: "08.00 - 16.00" },
    { days: "Fredag", time: "08.00 - 14.30" },
    { days: "Lørdag - Søndag", time: "Lukket" }
  ]
};
